import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-message-danger min-h-0" }
const _hoisted_2 = { class: "ml-s1" }

import { useI18n } from 'vue-i18n';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceImpactErrorMessage',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_unref(t)('singleSide.infoMessage.priceImpactTooBig.caption')), 1),
    _createVNode(TooltipIcon, {
      tooltip: _unref(t)('singleSide.infoMessage.priceImpactTooBig.tooltip'),
      color: "danger",
      inline: ""
    }, null, 8, ["tooltip"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('singleSide.infoMessage.decreaseAmount')), 1)
  ]))
}
}

})